import React from 'react'

export function ComesForm() {
  return (
    <div>Comes Form</div>
  )
}
